<template>
    <div class="app-container">
        <div class="wrap">
            <navBar :title="'付款管理'" @handleGoBack="handleGoBack">
            </navBar>

            <div class="common-wrap">
                <van-search
                        show-action
                        v-model="queryParams.name"
                        placeholder="请输入编号/标题"
                        @search="handleQuery"
                >
                    <template #action>
                        <div class="search-btn-label" @click="handleQuery">搜索</div>
                    </template>
                </van-search>
            </div>

            <van-tabs class="my-tabs" @click="getListParams" v-model="active" ref="tabsRef">
                <van-tab title="销售付款" :color="'#0091FF'" v-if="this.$auth.hasPermi('cw:crmPay:list')">
                    <div class="main">
                        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                            <van-list
                                    v-model="loading"
                                    offset="100"
                                    :finished="finished"
                                    finished-text="没有更多了"
                                    @load="onLoad"
                            >
                                <div class="list" v-for="item in dataList" :key="item.id">
                                    <div class="line"></div>
                                    <div class="item-tab" @click="handleGoDetail(item.id)">
                                        <div class="title-wrap flex-spa-ver-cen">
                                            <div class="tit over_hidden">
                                                {{ item.name || '--' }}
                                            </div>
                                        </div>
                                        <div class="con">
                                            <div class="desc-wrap flex">
                                                <div class="label">客户名称：</div>
                                                <div class="value">{{ item.customerName || '--' }}</div>
                                            </div>
                                            <div class="desc-wrap flex">
                                                <div class="label">关联订单：</div>
                                                <div class="value">{{ item.orderName }}</div>
                                            </div>
                                            <div class="desc-wrap flex">
                                                <div class="label">总金额：</div>
                                                <div class="value red">{{ item.planPrice }}</div>
                                            </div>
                                            <div class="desc-wrap flex">
                                                <div class="label">待付金额：</div>
                                                <div class="value red">{{ item.notYerPrice }}</div>
                                            </div>
                                        </div>
                                        <div class="time-wrap flex-spa-ver-cen">
                                            <div class="time">创建日期：{{ item.createTime || '--' }}</div>
                                            <van-icon name="weapp-nav"/>
                                        </div>
                                    </div>
                                </div>
                            </van-list>
                        </van-pull-refresh>
                    </div>
                </van-tab>
                <van-tab title="采购付款" :color="'#0091FF'" v-if="this.$auth.hasPermi('cw:payment:list')">
                    <div class="main">
                        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                            <van-list
                                    v-model="loading"
                                    offset="100"
                                    :finished="finished"
                                    finished-text="没有更多了"
                                    @load="onLoad"
                            >
                                <div class="list" v-for="item in dataList" :key="item.id">
                                    <div class="line"></div>
                                    <div class="item-tab" @click="handleGoDetail(item.id)">
                                        <div class="title-wrap flex-spa-ver-cen">
                                            <div class="tit over_hidden">
                                                {{ item.name || '--' }}
                                            </div>
                                            <div class="level-btn">
                                                {{ item.state }}
                                            </div>
                                        </div>
                                        <div class="con">
                                            <div class="desc-wrap flex">
                                                <div class="label">关联订单：</div>
                                                <div class="value">{{ item.order }}</div>
                                            </div>
                                            <div class="desc-wrap flex">
                                                <div class="label">总金额：</div>
                                                <div class="value red">{{ item.price }}</div>
                                            </div>
                                            <div class="desc-wrap flex">
                                                <div class="label">待还金额：</div>
                                                <div class="value red">{{ item.notYerPrice }}</div>
                                            </div>
                                        </div>
                                        <div class="time-wrap flex-spa-ver-cen">
                                            <div class="time">创建日期：{{ item.createTime || '--' }}</div>
                                            <van-icon name="weapp-nav"/>
                                        </div>
                                    </div>
                                </div>
                            </van-list>
                        </van-pull-refresh>
                    </div>
                </van-tab>
                <van-tab title="销售退款" :color="'#0091FF'" v-if="this.$auth.hasPermi('cw:return:list')">
                    <div class="main">
                        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                            <van-list
                                    v-model="loading"
                                    offset="100"
                                    :finished="finished"
                                    finished-text="没有更多了"
                                    @load="onLoad"
                            >
                                <div class="list" v-for="item in dataList" :key="item.id">
                                    <div class="line"></div>
                                    <div class="item-tab" @click="handleGoDetail(item.id)">
                                        <div class="title-wrap flex-spa-ver-cen">
                                            <div class="tit over_hidden">
                                                {{ item.theme || '--' }}
                                            </div>
                                            <div class="level-btn">
                                                {{ item.returnState || '--' }}
                                            </div>
                                        </div>
                                        <div class="con">
                                            <div class="desc-wrap flex">
                                                <div class="label">客户名称：</div>
                                                <div class="value">{{ item.customer || '--' }}</div>
                                            </div>
                                            <div class="desc-wrap flex">
                                                <div class="label">关联订单：</div>
                                                <div class="value">{{ item.order || '--' }}</div>
                                            </div>
                                            <div class="desc-wrap flex">
                                                <div class="label">总金额：</div>
                                                <div class="value">{{ item.refundAmount }}</div>
                                            </div>
                                            <div class="desc-wrap flex">
                                                <div class="label">负责人：</div>
                                                <div class="value red">{{ item.leaderId }}</div>
                                            </div>
                                            <div class="desc-wrap flex">
                                                <div class="label">退款日期：</div>
                                                <div class="value red">{{ item.returnDate }}</div>
                                            </div>
                                        </div>
                                        <div class="time-wrap flex-spa-ver-cen">
                                            <div class="time">创建日期：{{ item.createTime || '--' }}</div>
                                            <van-icon name="weapp-nav"/>
                                        </div>
                                    </div>
                                </div>
                            </van-list>
                        </van-pull-refresh>
                    </div>
                </van-tab>
                <van-tab title="生产付款" :color="'#0091FF'" v-if="this.$auth.hasPermi('cw:proPayment:list')">
                    <div class="main">
                        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                            <van-list
                                    v-model="loading"
                                    offset="100"
                                    :finished="finished"
                                    finished-text="没有更多了"
                                    @load="onLoad"
                            >
                                <div class="list" v-for="item in dataList" :key="item.id">
                                    <div class="line"></div>
                                    <div class="item-tab" @click="handleGoDetail(item.id)">
                                        <div class="title-wrap flex-spa-ver-cen">
                                            <div class="tit over_hidden">
                                                {{ item.paymentName || '--' }}
                                            </div>
                                            <div class="level-btn">
                                                {{ item.paymentStateName || '--' }}
                                            </div>
                                        </div>
                                        <div class="con">
                                            <div class="desc-wrap flex">
                                                <div class="label">加工商：</div>
                                                <div class="value">{{ item.name || '--' }}</div>
                                            </div>
                                            <div class="desc-wrap flex">
                                                <div class="label">关联订单：</div>
                                                <div class="value">{{ item.subcontractTitle || '--' }}</div>
                                            </div>
                                            <div class="desc-wrap flex">
                                                <div class="label">待还金额：</div>
                                                <div class="value">{{ item.paymentNoPrice }}</div>
                                            </div>
                                            <div class="desc-wrap flex">
                                                <div class="label">到期日期：</div>
                                                <div class="value red">{{ item.finallyTime }}</div>
                                            </div>
                                        </div>
                                        <div class="time-wrap flex-spa-ver-cen">
                                            <div class="time">创建日期：{{ item.createTime || '--' }}</div>
                                            <van-icon name="weapp-nav"/>
                                        </div>
                                    </div>
                                </div>
                            </van-list>
                        </van-pull-refresh>
                    </div>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script>
    import {findPage} from '@/api/crm/pay/index';
    import {getAllPaymentList} from '@/api/cw/payment/payment';
    import {getAllReturnList} from '@/api/cw/reurn/return'
    import {getAllProPaymentList} from '@/api/cw/proPayment/proPayment'

    export default {
        data() {
            return {
                loading: false,
                finished: false,
                refreshing: false, // 下拉
                tabTitle: '',
                active: 0,
                queryParams: {
                    pageNum: 1,
                    pageSize: 5
                },
                dataList: []
            };
        },

        mounted() {
            this.tabTitle = this.$refs.tabsRef.children[0].title
            this.getList()
        },

        methods: {
            handleGoBack() {
                this.$router.replace('/cw/cwWorkbench');
                this.$router.go(-1)
            },

            async getList() {
                this.loading = true;
                let result = {}
                if (this.tabTitle == '销售付款') {
                    this.queryParams.screen = 0
                    result = await findPage(this.queryParams)
                } else if (this.tabTitle == '采购付款') {
                    result = await getAllPaymentList(this.queryParams)
                } else if (this.tabTitle == '销售退款') {
                    this.queryParams.theme = this.queryParams.name
                    result = await getAllReturnList(this.queryParams)
                } else if (this.tabTitle == '生产付款') {
                    this.queryParams.paymentName = this.queryParams.name
                    result = await getAllProPaymentList(this.queryParams)
                }

                const {records = [], total = 0} = result.data;
                // 空数组
                if (records.length == 0) {
                    this.dataList = [];
                    this.finished = true;
                    this.loading = true;
                    return;
                }
                if (this.queryParams.pageNum == 1) {
                    this.dataList = records;
                } else {
                    this.dataList = [...this.dataList, ...records];
                }
                this.finished = false;
                this.loading = false;
                this.queryParams.pageNum += 1;
                const end = records.length; //已获取的数据的总条数
                if (end >= total) {
                    //如果两个相等就停止加载，显示没有更多
                    this.finished = true;
                    return;
                }

                this.total = total;
            },

            onLoad() {
                if (this.refreshing) {
                    this.dataList = [];
                    this.refreshing = false;
                    this.queryParams.pageNum = 1;
                }
                if (this.dataList.length == this.total) {
                    this.finished = true;
                    return;
                }
                this.loading = true;
                this.getList();
            },

            //下拉的话refreshing为true
            onRefresh() {
                this.finished = false;
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = false;
                this.onLoad();
            },

            getListParams(index) {
                this.finished = false;
                this.loading = false;
                this.dataList = [];
                this.queryParams.screen = index;
                this.handleQuery();
            },

            /** 搜索按钮操作 */
            handleQuery() {
                this.queryParams.pageNum = 1;
                this.getList();
            },

            handleGoDetail(id) {
                let path = this.tabTitle == '销售付款' ? 'salePay' : (this.tabTitle == '采购付款' ? 'purPay' : (this.tabTitle == '销售退款' ? 'saleReturn' : 'proPay'))
                // 进入详情页面
                this.$router.push({
                    path: '/cw/' + path + '/add',
                    query: {
                        id
                    },
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
  .wrap {
    background: #fff;
  }

  .search {
    padding-top: 40px;
    background: #fff;
  }

  .my-tabs {
    padding-top: 30px;
  }

  .item-tab {
    padding: 0 33px;
    margin-top: 30px;

    .title-wrap {
      padding: 20px 0;

      .tit {
        font-size: 32px;
        font-weight: bold;
        color: #111111;
        line-height: 38px;
        width: 0;
        flex: 1;
      }

      .level-btn {
        width: 150px;
        height: 40px;
        background: #f7ad00;
        border-radius: 4px 4px 4px 4px;
        color: #fff;
        text-align: center;
        line-height: 40px;
        font-size: 28px;
      }
    }

    .con {
      padding: 20px 0;
      border-top: 1px solid #f3f3f3;
      border-bottom: 1px solid #f3f3f3;

      .desc-wrap {
        font-size: 28px;
        margin-bottom: 20px;

        .label {
          white-space: nowrap;
          color: #999;
        }

        .value {
          color: #111;
          white-space: nowrap;
          overflow: hidden;
        }

        .red {
          color: #f7ad00;
        }
      }

      .desc-wrap:last-child {
        margin-bottom: 0;
      }
    }

    .time-wrap {
      font-size: 26px;
      margin: 20px 0 20px;
    }
  }

  ::v-deep .van-tabs__line {
    background-color: #0091ff;
  }

  .transfer-select-wrap {
    font-size: 28px;
  }

  ::v-deep .van-checkbox__label {
    line-height: 40px;
    font-size: 28px;
    padding-top: 10px;
  }

  ::v-deep .van-checkbox__icon .van-icon {
    width: 28px;
    height: 28px;
  }
</style>
